module.exports = "<p>\n  reservation-create works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reservation/reservation-create/reservation-create.component.html
// module id = ./src/app/reservation/reservation-create/reservation-create.component.html
// module chunks = main